import React from 'react';

const DetailLabel = ({label, children, className, style}) => {
	return (
		<label className={`colour-text-label-grey transition-fade-up${className ? ' ' + className : ''}`} style={{...style}}>{label || children}</label>
   );
}

export default DetailLabel;